import { api } from '@/main'

const defaultState = {
  currentRecordTenants: [],
  currentRecordGuarantors: [],
  guarantType: '0',
  guarantId: null,
  tenantId: null
}

export default {
  namespaced: true,
  state: {
    ...defaultState
  },
  mutations: {
    RESET_MODULE: state => {
      Object.keys(state).forEach(key => {
        state[key] = defaultState[key]
      })
    },
    SET_CURRENT_RECORD_DATA: (state, data) => {
      state.currentRecordTenants = [...data.tenants]
      state.currentRecordGuarantors = [...data.guarantors]
    },
    SET_GUARANT_TYPE: (state, guarantType) => (state.guarantType = guarantType),
    SET_GUARANT_ID: (state, guarantId) => (state.guarantId = guarantId),
    SET_TENANT_ID: (state, tenantId) => (state.tenantId = tenantId),
    ADD_PERSON: (state, { type, data }) => {
      state[
        'currentRecord' + (type === 'tenant' ? 'Tenants' : 'Guarantors')
      ].push(data)
    },
    UPDATE_PERSON: (state, { type, data }) => {
      state[
        'currentRecord' + (type === 'tenant' ? 'Tenants' : 'Guarantors')
      ] = [
        ...state[
          'currentRecord' + (type === 'tenant' ? 'Tenants' : 'Guarantors')
        ].filter(person => person.id !== data.id),
        data
      ]
    }
  },
  actions: {
    resetModule(store) {
      store.commit('RESET_MODULE')
    },
    async getCurrentRecordPeople(store) {
      const record = store.rootState.records.currentRecord
      let tenants = []
      let guarantors = []

      if (record) {
        if (record.tenant_ids && record.tenant_ids.length > 0) {
          for await (let id of record.tenant_ids) {
            tenants.push(await api.recordsPeople.getTenant({ id }))
          }
        }

        if (record.guarantor_ids && record.guarantor_ids.length > 0) {
          for await (let id of record.guarantor_ids) {
            guarantors.push(await api.recordsPeople.getGuarantor({ id }))
          }
        }

        store.commit('SET_CURRENT_RECORD_DATA', {
          tenants,
          guarantors
        })
      }
    },
    async createGuarantor(store, params) {
      const r = await api.recordsPeople.createGuarantor(params)

      store.commit('ADD_PERSON', {
        type: 'guarantor',
        data: r
      })

      store.dispatch(
        'records/addPersonToCurrentRecord',
        {
          type: 'guarantor',
          id: r.id
        },
        { root: true }
      )

      await store.dispatch(
        'recordsDocuments/getRecordPeopleDocuments',
        {
          type: 'guarantor',
          id: r.id
        },
        { root: true }
      )
    },
    async updateGuarantor(store, params) {
      const r = await api.recordsPeople.updateGuarantor(params)

      store.commit('UPDATE_PERSON', {
        type: 'guarantor',
        data: r
      })
    },
    async createTenant(store, params) {
      const r = await api.recordsPeople.createTenant(params)

      store.commit('ADD_PERSON', {
        type: 'tenant',
        data: r
      })

      store.dispatch(
        'records/addPersonToCurrentRecord',
        {
          type: 'tenant',
          id: r.id
        },
        { root: true }
      )

      await store.dispatch(
        'recordsDocuments/getRecordPeopleDocuments',
        {
          type: 'tenant',
          id: r.id
        },
        { root: true }
      )
    },
    async updateTenant(store, params) {
      const r = await api.recordsPeople.updateTenant(params)

      store.commit('UPDATE_PERSON', {
        type: 'tenant',
        data: r
      })
    },
    setGuarantType(store, guarantType) {
      store.commit('SET_GUARANT_TYPE', guarantType)
    },
    setGuarantId(store, guarantId) {
      store.commit('SET_GUARANT_ID', guarantId)
    },
    setTenantId(store, tenantId) {
      store.commit('SET_TENANT_ID', tenantId)
    },
    async deletePerson(store, params) {
      await api.recordsPeople[
        'delete' + (params.type === 'guarant' ? 'Guarantor' : 'Tenant')
      ]({ id: params.id })

      await store.dispatch('records/refreshCurrentRecord', null, { root: true })
    }
  },
  getters: {
    guarantType: state => state.guarantType,
    guarantId: state => state.guarantId,
    tenantId: state => state.tenantId
  }
}
